import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom';
import { Navbar } from '../components/ui/Navbar';
import { MarvelScreen } from '../components/marvel/MarvelScreen';
import { HerosScreen } from '../components/heroes/HerosScreen';
import { DcScreen } from '../components/dc/DcScreen';
import { SearchScreen } from '../components/search/SearchScreen';


export const DashboardRoutes = () => {
    return (
        <>
            <Navbar />
            <div className= "container mt-2">
                <Switch>
                    <Route exact path="/marvel" component={ MarvelScreen } />
                    <Route exact path="/hero/:heroeId" component={ HerosScreen } />
                    <Route exact path="/dc" component={DcScreen} />
                    <Route exact path="/search" component={ SearchScreen } />
                    <Redirect to="/marvel" />

                </Switch>
            </div>
        </>
    )
}
